import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import { Images } from "assets";
import { JobRole } from "shared/utils/enum";
import styles from "./styles";

// Create Document Component
const PDFDocument = ({ data }: any) => {
  let date = new Date(data?.created_at);
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formattedDate = date.toLocaleDateString("en-US", options);
  return (
    <>
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.mainContainer}>
            <View style={styles.mainDetails}>
              <View style={styles.dateContainer}>
                <Text style={[styles.dateText, styles.bold]}>
                  Evaluation Date:
                </Text>
                <Text style={[styles.dateText]}>{formattedDate}</Text>
              </View>
              <View style={styles.leftSide}>
                <Text style={[styles.upperText, styles.bold]}>
                  Company Name:{" "}
                </Text>
                <Text style={[styles.upperText, styles.bold]}>Job Title: </Text>
                <Text style={[styles.upperText, styles.bold]}>Role Type: </Text>
                <Text style={[styles.upperText, styles.bold]}>
                  CGP RAS Code:{" "}
                </Text>
                <Text style={[styles.upperText, styles.bold]}>
                  Total RAS Points:{" "}
                </Text>
              </View>
              <View style={styles.rightSide}>
                <Text style={styles.upperText}>{data?.orgName} </Text>
                <Text style={styles.upperText}>{data?.jobTitle}</Text>
                <Text style={styles.upperText}>
                  {data?.roleType === JobRole.individualContributor
                    ? "Indivial Contirbutor"
                    : "Management"}
                </Text>
                <Text style={styles.upperText}>{data?.shortCode} </Text>
                <Text style={styles.upperText}>{data?.rasScore} </Text>
              </View>
            </View>
            <View style={styles.tableContainer}>
              <View style={styles.firstSection}>
                <View style={styles.flexOne}>
                  <View
                    style={[
                      styles.firstSectionFirstRow,
                      { borderLeftColor: "#1a1919" },
                    ]}
                  ></View>
                </View>
                <View style={styles.flexFour}>
                  <View style={styles.firstSectionFirstRow}>
                    <Text style={styles.yellowText}>Component</Text>
                  </View>
                </View>
                <View style={styles.flexTwo}>
                  <View style={styles.firstSectionFirstRow}>
                    <Text style={styles.yellowText}>Symbol</Text>
                  </View>
                </View>
                <View style={styles.flexTwo}>
                  <View style={styles.firstSectionFirstRow}>
                    <Text style={styles.yellowText}>Output</Text>
                  </View>
                </View>
                <View style={styles.flex20}>
                  <View style={styles.firstSectionFirstRow}>
                    <Text style={styles.yellowText}>Description</Text>
                  </View>
                </View>
              </View>
              <View style={styles.secondSection}>
                <View style={styles.knowledgeHeadingCont}>
                  <View style={styles.rotateBox1}>
                    <Text style={[styles.upperText, styles.bold]}>
                      Knowledge & Skill (K&S)
                    </Text>
                  </View>
                </View>
                <View style={styles.knowledgeDetailsCont}>
                  <View style={styles.secondSectionRow}>
                    <View style={styles.secondFlexFour}>
                      <View style={styles.innerFour}>
                        <Text style={styles.upperTextCenter}>
                          Level of Work & Modifier
                        </Text>
                      </View>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.level_of_work?.roleId ===
                        Number(JobRole.individualContributor)
                          ? "IC"
                          : "MG"}
                      </Text>
                      <Text style={styles.upperTextCenter}>
                        {data?.modifier}
                      </Text>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.modifierScore}
                      </Text>
                    </View>
                    <View style={styles.secondFlex20}>
                      <View style={styles.inner20}>
                        <Text style={[styles.upperText, { textAlign: "left" }]}>
                          {data?.level_of_work?.long_des}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.secondSectionRow}>
                    <View style={styles.secondFlexFour}>
                      <View style={styles.innerFour}>
                        <Text style={styles.upperTextCenter}>
                          Institutional Expertise & Scope (IE&S)
                        </Text>
                      </View>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.q2?.level}
                      </Text>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.q2?.score}
                      </Text>
                    </View>
                    <View style={styles.secondFlex20}>
                      <View style={styles.inner20}>
                        <Text style={[styles.upperText, { textAlign: "left" }]}>
                          {data?.q2?.long_des}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.secondSectionRow}>
                    <View style={styles.secondFlexFour}>
                      <View style={styles.innerFour}>
                        <Text style={styles.upperTextCenter}>
                          Cultural Impact & Communication
                        </Text>
                      </View>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.q3?.level}
                      </Text>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.q3?.score}
                      </Text>
                    </View>
                    <View style={styles.secondFlex20}>
                      <View style={styles.inner20}>
                        <Text style={[styles.upperText, { textAlign: "left" }]}>
                          {data?.q3?.long_des}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
              <View style={styles.secondSection}>
                <View style={styles.knowledgeHeadingCont}>
                  <View style={styles.rotateBox2}>
                    <Text style={[styles.upperText, styles.bold]}>
                      Working Environment
                    </Text>
                  </View>
                </View>
                <View style={styles.knowledgeDetailsCont}>
                  <View style={styles.secondSectionRow}>
                    <View style={styles.secondFlexFour}>
                      <View style={styles.innerFour}>
                        <Text style={styles.upperTextCenter}>
                          Physical Environment
                        </Text>
                      </View>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.q4?.level}
                      </Text>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.q4?.score}
                      </Text>
                    </View>
                    <View style={styles.secondFlex20}>
                      <View style={styles.inner20}>
                        <Text style={[styles.upperText, { textAlign: "left" }]}>
                          {data?.q4?.long_des}
                        </Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.secondSectionRow}>
                    <View style={styles.secondFlexFour}>
                      <View style={styles.innerFour}>
                        <Text style={styles.upperTextCenter}>
                          Mental / Emotional Environment
                        </Text>
                      </View>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.q5?.level}
                      </Text>
                    </View>
                    <View style={styles.secondFlexTwo}>
                      <Text style={styles.upperTextCenter}>
                        {data?.q5?.score}
                      </Text>
                    </View>
                    <View style={styles.secondFlex20}>
                      <View style={styles.inner20}>
                        <Text style={[styles.upperText, { textAlign: "left" }]}>
                          {data?.q5?.long_des}
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
              <View style={styles.secondSection}>
                <View style={styles.flexFive}>
                  <View style={styles.innerFour}>
                    <Text style={styles.upperTextCenter}>
                      Application of K&S
                    </Text>
                  </View>
                </View>
                <View style={styles.secondFlexTwo}>
                  <Text style={styles.upperTextCenter}>{data?.q6?.level}</Text>
                </View>
                <View style={styles.secondFlexTwo}>
                  <Text style={styles.upperTextCenter}>{data?.q6?.score}</Text>
                </View>
                <View style={styles.secondFlex20}>
                  <View style={styles.inner20}>
                    <Text style={[styles.upperText, { textAlign: "left" }]}>
                      {data?.q6?.long_des}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.secondSection}>
                <View style={styles.flexFive}>
                  <View style={styles.innerFour}>
                    <Text style={styles.upperTextCenter}>Manual Effort</Text>
                  </View>
                </View>
                <View style={styles.secondFlexTwo}>
                  <Text style={styles.upperTextCenter}>{data?.q7?.level}</Text>
                </View>
                <View style={styles.secondFlexTwo}>
                  <Text style={styles.upperTextCenter}>{data?.q7?.score}</Text>
                </View>
                <View style={styles.secondFlex20}>
                  <View style={styles.inner20}>
                    <Text style={[styles.upperText, { textAlign: "left" }]}>
                      {data?.q7?.long_des}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.secondSection}>
                <View style={styles.flexFive}>
                  <View style={styles.innerFour}>
                    <Text style={styles.upperTextCenter}>Outcomes</Text>
                  </View>
                </View>
                <View style={styles.secondFlexTwo}>
                  <Text style={styles.upperTextCenter}>{data?.q8?.level}</Text>
                </View>
                <View style={styles.secondFlexTwo}>
                  <Text style={styles.upperTextCenter}>
                    {data?.roleType === JobRole.individualContributor
                      ? data?.q8?.score
                      : data?.outcomeScore}
                  </Text>
                </View>
                <View style={styles.secondFlex20}>
                  <View style={styles.inner20}>
                    <Text style={[styles.upperText, { textAlign: "left" }]}>
                      {data?.q8?.long_des}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={[styles.secondSection, { minHeight: "50px" }]}>
                <View style={styles.flexNine}>
                  <View style={styles.innerFour}>
                    <Text style={styles.upperTextCenter}>Notes / Comments</Text>
                  </View>
                </View>
                <View style={styles.secondFlex20}>
                  <View style={styles.inner20}>
                    <Text style={[styles.upperText, { textAlign: "left" }]}>
                      {data?.q9}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles.footerContainer}>
              <View style={styles.flexOne} />
              <View
                style={[
                  styles.flexOne,
                  { justifyContent: "center", alignItems: "center" },
                ]}
              >
                <Text style={styles.dateText}>
                  2024 Compensation Governance Partners. All rights reserved
                </Text>
              </View>
              <View
                style={[
                  styles.flexOne,
                  {
                    justifyContent: "center",
                    alignItems: "flex-end",
                    paddingRight: "10px",
                  },
                ]}
              >
                <Image src={Images.Logo} style={{ width: "150px" }} />
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </>
  );
};

export default PDFDocument;
